import React from "react";
import { Box } from "digiwash-components";

interface PropsType {
  ratio: string;
  children?: React.ReactNode;
  fixedWidth?: number;
}

function BoxRatio(props: PropsType) {
  let [w, h] = props.ratio.split(":");

  let height = (Number(h) * props.fixedWidth) / Number(w);

  return !!height ? (
    <Box
      br="m"
      style={{
        width: "100%",
        height: height,
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Box
        style={{
          width: "100%",
          height: "100%",
          position: "absolute",
          top: 0,
          left: 0,
        }}
      >
        {props.children}
      </Box>
    </Box>
  ) : null;
}

export default BoxRatio;
